import { render, staticRenderFns } from "./MoveToDialog.vue?vue&type=template&id=61f19a58"
import script from "./MoveToDialog.vue?vue&type=script&lang=js"
export * from "./MoveToDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports